module.exports = __webpack_public_path__ + "img/weblogo.aa3e6073.png";